(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klaviyo-bis')) {
    customElements.define('klaviyo-bis', class KlaviyoBis extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.getAttribute('form-id'));
        this.modal = this.querySelector('modal-content');
        this.optionsEl = this.querySelector('[data-klaviyo-bis-options]');
        this.fieldsEl = this.querySelector('[data-klaviyo-bis-fields]');
        this.successEl = this.querySelector('[data-klaviyo-bis-success]');
        this.errorEl = this.querySelector('[data-klaviyo-bis-error]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitting = false;
        this.onVariantChanged = this.onVariantChanged.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onModalOpenChange = this.onModalOpenChange.bind(this);

        this.form?.addEventListener('variant:changed', this.onVariantChanged);
        this.fieldsEl?.addEventListener('submit', this.onSubmit);
        this.observer = new MutationObserver(this.onModalOpenChange);
        if (this.modal) {
          this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
        }
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:changed', this.onVariantChanged);
        this.fieldsEl?.removeEventListener('submit', this.onSubmit);
        this.observer?.disconnect();
      }

      get bisKey() {
        return this.getAttribute('bis-key');
      }

      get containers() {
        return document.querySelectorAll(`[data-klaviyo-bis="${this.bisKey}"]`);
      }

      onVariantChanged(event) {
        const variant = event.detail.variant;
        const soldOut = Boolean(variant && !variant.available);

        this.containers.forEach((container) => {
          container.classList.toggle('is-notify', soldOut);
        });

        this.renderOptions(variant);
      }

      renderOptions(variant) {
        if (!this.optionsEl) return;

        const names = JSON.parse(this.optionsEl.getAttribute('data-option-names') || '[]');
        const values = variant?.options || [];
        const hasOptions = values.some((value) => value && value !== 'Default Title');

        this.optionsEl.hidden = !hasOptions;
        this.optionsEl.replaceChildren();

        names.forEach((name, index) => {
          const value = values[index];
          if (!value || value === 'Default Title') return;

          const item = document.createElement('li');
          const nameEl = document.createElement('span');
          nameEl.className = 'klaviyo-bis__option-name';
          nameEl.textContent = `${name}:`;
          const valueEl = document.createElement('span');
          valueEl.className = 'klaviyo-bis__option-value';
          valueEl.textContent = value;
          item.append(nameEl, document.createTextNode(' '), valueEl);
          this.optionsEl.append(item);
        });
      }

      onModalOpenChange() {
        if (this.modal?.hasAttribute('open')) return;
        this.resetMessages();
        if (this.fieldsEl) this.fieldsEl.hidden = false;
      }

      resetMessages() {
        if (this.successEl) this.successEl.hidden = true;
        if (this.errorEl) this.errorEl.hidden = true;
      }

      async onSubmit(event) {
        event.preventDefault();

        if (this.submitting) return;

        const email = this.fieldsEl.querySelector('[name="email"]')?.value.trim();
        const variantId = this.form?.querySelector('[name="id"]')?.value;
        const companyId = this.getAttribute('company-id');

        if (!email || !variantId || !companyId) return;

        this.resetMessages();
        this.submitting = true;
        this.submitButton.disabled = true;

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`,
            {
              method: 'POST',
              headers: {
                accept: 'application/json',
                revision: '2024-10-15',
                'content-type': 'application/json'
              },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email
                        }
                      }
                    },
                    channels: ['EMAIL']
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: `$shopify:::$default:::${variantId}`
                      }
                    }
                  }
                }
              })
            }
          );

          if (!response.ok) throw new Error('request_failed');

          this.fieldsEl.hidden = true;
          if (this.successEl) this.successEl.hidden = false;
        } catch (error) {
          if (this.errorEl) this.errorEl.hidden = false;
        } finally {
          this.submitting = false;
          this.submitButton.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
